import { useModernComponent } from '~/hooks';
import { IAvatarList } from './Types';
import { AvatarListLegacy } from './AvatarListLegacy';
import { AvatarList } from './AvatarList';

export const AvatarListProxy = ({ onSelect, selected, horizontal = false }: IAvatarList) => {
  const isUseModern = useModernComponent('commons.AvatarList');

  if (isUseModern) {
    return <AvatarList horizontal={horizontal} selected={selected} onSelect={onSelect} />;
  }

  return <AvatarListLegacy horizontal={horizontal} selected={selected} onSelect={onSelect} />;
};
